import modalZoomImageComponent from './modal-zoom-image/modal-zoom-image.component';
import modalTermsConditionsComponent from './modal-terms-conditions/modal-terms-conditions.component';
import modalIframeComponent from './modal-iframe/modal-iframe.component';

/* @ngInject */
export default function ModalFactory(ModalService) {

  function showZoomImage(bindings = {}) {
    return ModalService.showModal(Object.assign({}, modalZoomImageComponent, {inputs: bindings}));
  }

  function showTermsAndConditions(bindings = {}) {
    return ModalService.showModal(Object.assign({}, modalTermsConditionsComponent, {inputs: bindings}));
  }
  function showIframeModal(bindings = {}) {
    return ModalService.showModal(Object.assign({}, modalIframeComponent, {inputs: bindings}));
  }

  return {
    showZoomImage,
    showTermsAndConditions,
    showIframeModal,
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.factory.js